<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessImportHistory.page.ColumnCode')" prop="columnCode">
            <BjInput v-model="queryParams.columnCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessImportHistory.page.ColumnName')" prop="columnName">
            <BjInput v-model="queryParams.columnName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessImportGeneralColumn_Add type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'nullableFlag'">
                <el-tag :type="row.nullableFlag ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}
                </el-tag>
              </template>
              <template v-else-if="col.prop === 'validateFlag'">
                <el-tag :type="row.validateFlag ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}
                </el-tag>
              </template>
              <template v-else-if="col.prop === 'enabledFlag'">
                <el-tag :type="row.enabledFlag ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(row[col.prop])) }}
                </el-tag>
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="{ row }">
              <el-button v-permission:BusinessImportGeneralColumn_Edit type="text" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button v-permission:BusinessImportGeneralColumn_Delete :disabled="!!row.enabledFlag" type="text" @click="onDelete(row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <ColumnViewData :id="this.$route.query.id" ref="viewData" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { importApi } from '@/api';
import ColumnViewData from './components/columnViewData.vue';
import { STATUS_YES_NUM, STATUS_ENABLED_NUM } from '@/utils/constants';
export default {
  name: 'BusinessImportGeneralColumn',
  components: { ColumnViewData },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_YES_NUM,
      STATUS_ENABLED_NUM,
      serial: false,
      selection: false,
      queryParams: {
        targetId: this.$route.query.id,
        columnCode: null,
        columnName: null,
      },
      queryApi: importApi.getTemplateLines,
      colSpan: 6,
      labelsVersion: 0,
      labelList: [
        { label: 'BusinessImportHistory.page.ColumnCode', prop: 'columnCode', isCheck: true, disabled: false, width: 110 },
        { label: 'BusinessImportHistory.page.ColumnName', prop: 'columnName', isCheck: true, disabled: false, width: 115 },
        { label: 'BusinessImportHistory.page.ColumnType', prop: 'columnTypeMeaning', isCheck: true, disabled: false, width: 101 },
        { label: 'BusinessImportHistory.page.FormatMask', prop: 'formatMask', isCheck: true, disabled: false, width: 101 },
        { label: 'BusinessImportHistory.page.Length', prop: 'length', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.Maximum', prop: 'maxValue', isCheck: true, disabled: false, width: 107 },
        { label: 'BusinessImportHistory.page.Minimum', prop: 'minValue', isCheck: true, disabled: false, width: 119 },
        { label: 'BusinessImportHistory.page.ValidateValue', prop: 'validateSet', isCheck: true, disabled: false, width: 144 },
        { label: 'BusinessImportHistory.page.RegularExpression', prop: 'regularExpression', isCheck: true, disabled: false, width: 138 },
        { label: 'BusinessImportHistory.page.NullAllowed', prop: 'nullableFlag', isCheck: true, disabled: false, width: 101 },
        { label: 'BusinessImportHistory.page.DataValidation', prop: 'validateFlag', isCheck: true, disabled: false, width: 123 },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
    };
  },
  watch: {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
    onAdd() {
      this.$refs.viewData.show();
    },
    onEdit(row) {
      const { id } = row;
      importApi['getTemplateLinesDetail']({ lineId: id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$refs.viewData.show(res);
        }
      });
    },
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi(row);
        })
        .catch(() => {});
    },
    deleteApi(data) {
      importApi.deleteTemplateLines(data).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
